import { Center } from '@starryui10/layouts/Center';
import * as React from 'react';
import { BarLoader } from 'react-spinners';
import styled from 'styled-components';
import { color as colour } from '../theme/color';
import { Text } from '@starryui10/typography/Text';

interface IAreaLoaderProps {
    caption: string;
    color?: string;
}

export const AreaLoader: React.FunctionComponent<IAreaLoaderProps> = ({ caption, color = colour.Blue.B60 }) => {
    return (
        <AreaLoaderWrapper>
            <BarLoader color={color} />
            {caption && (
                <Center>
                    <Text>{caption}</Text>
                </Center>
            )}
        </AreaLoaderWrapper>
    );
};

const AreaLoaderWrapper = styled.div`
    width: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
    box-sizing: content-box;
    grid-column: 1 / all;
`;
